import { useTheme } from "@mui/material/styles";
import { useEffect } from "react";

export const HLJS_THEMES = {
  light: "https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.7.0/styles/atom-one-light.min.css",
  dark: "https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.7.0/styles/atom-one-dark.min.css",
};

export function useHighlightJsTheme() {
  const theme = useTheme();

  useEffect(() => {
    const existingLink = document.getElementById("hljs-theme");

    if (existingLink) {
      existingLink.setAttribute("href", HLJS_THEMES[theme.palette.mode as "light" | "dark"]);
    } else {
      const link = document.createElement("link");
      link.id = "hljs-theme";
      link.rel = "stylesheet";
      link.href = HLJS_THEMES[theme.palette.mode as "light" | "dark"];
      document.head.appendChild(link);
    }
  }, [theme.palette.mode]);
}
